import React, {useState} from 'react'

// const products = [
//     { id: 1, name: "Shirt", category: "Clothing", price: 20 },
//     { id: 2, name: "Pants", category: "Clothing", price: 30 },
//     { id: 3, name: "Shoes", category: "Footwear", price: 50 },
//     { id: 4, name: "Socks", category: "Footwear", price: 5 },
//     { id: 5, name: "Hat", category: "Accessories", price: 15 },
//     { id: 6, name: "Sunglasses", category: "Accessories", price: 25 },
//   ];

export const products = [
    { id: "M121", name: "Men in Suit", image: "assets/Men/casual/cc-1.jpg", price: "", desc: "", category: "Men Suit", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/casual/cc-2.jpg", price: "", desc: "", category: "Men Suit", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/casual/cc-3.jpg", price: "", desc: "", category: "Men Casual", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/casual/cc-4.jpg", price: "", desc: "", category: "Men Casual", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/suites/s-1.jpg", price: "", desc: "", category: "Men Formal", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/suites/s-2.jpg", price: "", desc: "", category: "Men Formal", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/suites/s-3.jpg", price: "", desc: "", category: "Men Party", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Men/suites/s-4.jpg", price: "", desc: "", category: "Men Party", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/office-wear/w-1.jpg", price: "", desc: "", category: "Woman Office", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/office-wear/w-2.jpg", price: "", desc: "", category: "Woman Office", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/office-wear/w-3.jpg", price: "", desc: "", category: "Woman Casual", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/office-wear/w-4.jpg", price: "", desc: "", category: "Woman Casual", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/Wcasual/wc-1.jpg", price: "", desc: "", category: "Woman Party", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/Wcasual/wc-2.jpg", price: "", desc: "", category: "Woman Party", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/Wcasual/wc-3.jpg", price: "", desc: "", category: "Woman Sarees", select: "", new: "NEW" },
    { id: "M121", name: "Men in Suit", image: "assets/Woman/Wcasual/wc-4.jpg", price: "", desc: "", category: "Woman Sarees", select: "", new: "NEW" },

]
  
  function FilterSec() {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const filteredProducts = selectedCategory === "All" ? products : products.filter(p => p.category === selectedCategory);
  
    return (
      <div>
        <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
          <option value="All">All</option>
          <option value="Men Suit">Men</option>
          <option value="Men Casual">Men Casual</option>
          <option value="Woman Casual">Woman</option>
        </select>
        <ul>
          {filteredProducts.map(p => (
            <li key={p.id}>
              {p.name} - {p.price}
            </li>
          ))}
        </ul>
        <div>
            {filteredProducts.map((item)=>{
                return(
                    <div>
                        <img src={`${item.image}`} />
                    </div>
                )
            })}
        </div>
      </div>
    );
  }
  export default FilterSec;
